import React from 'react'

import { useSnackbar } from 'notistack'

import { ZrSwal, LoaderHandler } from 'utils'

const ZariContext = React.createContext({
  snack: null,
  toast: null,
  loader: {
    open: null,
    close: null
  }
})

const { Provider } = ZariContext

const ZariProvider = props => {
  const { enqueueSnackbar } = useSnackbar()

  const loader = {
    open: mensaje => LoaderHandler.openLoader({ mensaje }),
    close: () => LoaderHandler.closeLoader()
  }

  const snack = (tipo, mensaje) => {
    ZrSwal.showAlert({
      tipo,
      mensaje
    })
  }

  const toast = (tipo, mensaje) => {
    enqueueSnackbar(mensaje, {
      variant: tipo || 'default'
    })
  }

  return <Provider value={{ snack, toast, loader }}>{props.children}</Provider>
}

export { ZariProvider, ZariContext }
